import React, { Component } from "react";
import { connect } from "react-redux";
import produce from "immer";
import CreatePromotion from "../../store/prat_middleware/promotion/createPromotionMiddleware";
import { openDB } from "idb";

import "./style/promotion.scss";
import { Loader } from "../../components/loader";
import MTFTS from './preOPSOTypeBreakdown/mtfts';
import MtftsMskus from './preOPSOTypeBreakdown/mtftsMskus';
import TOTALROW from './preOPSOTypeBreakdown/total';
import CustomToast from '../../util-functions/customToast.jsx'
import PromotionMiddleware from '../../store/prat_middleware/gt/promotionMiddleware';

let preOpsoData = [];       // eslint-disable-line
// let isSaveDraft = false;
class MTFTSPromotion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRestrict_fromIdb: '',
      selectedStartWeek: "",
      selectedEndWeek: "",
      checked: false,
      switch: false,
      startDate: "",
      endDate: "",
      sync: false,
      expanded: false,
      indexing: [],
      data: undefined,
      isLoading: false,
      selectedAppyUom: "",
      selectedBuyType: "",
      selectedBuyUom: "",
      selectedDiscountType: "",
      selectedUom: "",
      selectedAppyOn: "",
      selectedSkuNormType: "",
      budgetRestriction: "isEmpty",
      skuNorm: "isEmpty",
      postAws: "isEmpty",
      activatedAws: "isEmpty",
      buyFrom: "isEmpty",
      buyTo: "isEmpty",
      awsBaseline: "isEmpty",
      otherDetails: "",
      norm: "isEmpty",
      dnds: "isStatic",
      total_vol: "isStatic",
      selectedSkuNormType_label: "",
      extra_profit: "isStatic",
      ROI: "isStatic",
      newPromotion: [],
      sku_uniqueIndex: "",
      draft: undefined,
      slabFrom: "isEmpty",
      slabTo: "isEmpty",
      slabNorm: "isEmpty",
      metaData: undefined,
      TotalBudget: "",
      TotalVolume: "",
      TotalCost: "",
      noNewProject: false,
      isPercentageValue: false,
      isMerge: false,
      iscalc: false,
      trash: false,
      isCalculationResult: false,
      selectedProjectForNewCode: undefined,
      selectedMskuForNewCode: undefined,
      selectedValueForNewProject: undefined,
      selectedmskuIndex: undefined,
      selectedpromotionIndex: undefined,
      forceState: false,
      testing: undefined,
      CSVHasError: false,
      CSVData: null
    };
  }

  onChange = (e, index) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  baselineChange = (e, skuIndex, promoInd) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    let value = e.target.value;
    value = parseFloat(value);
    console.log('90=>', e, skuIndex, promoInd)
    tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex].Baseline = value;
    this.setState({
      data: tempData
    }, () => this.handleAllMskusCalculation()
      // this.dndsVal(
      //   tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex],
      //   promoInd,
      //   skuIndex,
      //   tempData.ActivityDuration
      // ) // here sequesncy is pre activated weeks, activated weks, dip weeks)
    );
  };

  // dndsVal(api, promoInd, skuIndex, ActivityDuration) {
  //   let tempData = JSON.parse(JSON.stringify(this.state.data));
  //   let dnds = (api.PreActivityWeeks + ActivityDuration + api.DipWeeks) * api.Baseline;
  //   tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex].DndsVolume = !dnds ? 0 : dnds.toFixed(2) * 1;
  //   console.log('108=>', { dnds }, { api }, { tempData })
  //   this.setState({
  //     data: tempData
  //   },
  //     () =>
  //       this.totalVol(api, promoInd, skuIndex, tempData.ActivityDuration)
  //   );

  // };

  // totalVol(api, promoInd, skuIndex, ActivityDuration) {
  //   let tempData = JSON.parse(JSON.stringify(this.state.data));
  //   let norm_delta = (parseFloat(api.Norm) / parseFloat(api.OrgNorm)) * 100;
  //   let total_activatedVol = api.ActivatedAws * ActivityDuration

  //   let total_vol = (api.PreActivityWeeks * api.Baseline) + (ActivityDuration * (api.ActivatedAws + api.Baseline)) + (api.DipWeeks * api.PostAws);

  //   let incValue = total_vol - api.DndsVolume; // this is also extra volume
  //   let extra_profit = (incValue.toFixed(2) * 1) * api.GpTon * 1000;

  //   if (tempData.Promotions[promoInd] && tempData.Promotions[promoInd].SkuVolumeAnalysis) {
  //     tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex].TotalActivatedVolume = !total_activatedVol ? 0 : total_activatedVol.toFixed(2) * 1;
  //     tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex].IncVolume = !incValue ? 0 : incValue.toFixed(2) * 1;
  //     tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex].TotalVolume = !total_vol ? 0 : total_vol.toFixed(2) * 1;
  //     tempData.extra_profit = extra_profit.toFixed(2) * 1;
  //     tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex].Percentage = !norm_delta || norm_delta === 'Infinity' ? 0 : norm_delta.toFixed(2) * 1;
  //     this.setState({
  //       data: tempData
  //     },
  //       () => this.totalCost(api, promoInd, skuIndex, ActivityDuration, extra_profit) // here sequesncy is pre activated weeks, activated weks, dip weeks
  //     )
  //   }

  // }

  // totalCost(api, promoInd, skuIndex, ActivityDuration, extra_profit) {
  //   try {
  //     this.calculateTotalCost(api, promoInd, skuIndex, ActivityDuration, extra_profit)
  //   }
  //   catch (e) {
  //   }
  // }

  // calculateTotalCost = (api, promoInd, skuIndex, ActivityDuration, extra_profit) => {
  //   !api.Grammage && CustomToast('warning', `there is no gramage in msku ${skuIndex}`)

  //   let tempData = JSON.parse(JSON.stringify(this.state.data));
  //   let total_act_vol = (api.Baseline + api.ActivatedAws) * ActivityDuration
  //   // let totalVol_value = parseFloat(api.TotalVolume);
  //   // let norm_value = !api.Norm ? 2 : api.Norm;      //removed this because of 2
  //   let norm_value = api.Norm;
  //   if (tempData.NormType === "b2e41bb3-a11d-48f1-b041-b9c04c956e7a") {  // NormType = FREE SKUs
  //     console.log('FIRST', tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex])
  //     let firstType = norm_value * total_act_vol * (api.Pricing * 1000 / api.Grammage);
  //     tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex].TotalCost = !firstType ? 0 : firstType.toFixed(2) * 1;
  //   }
  //   if (tempData.NormType === "2a48252b-4179-4090-98ac-a437728d5ed6" || tempData.Promotions[promoInd].Slabs) {  // NormType = DISCOUNT BY %AGE
  //     console.log('SECOND', tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex])
  //     let secondType = parseFloat(norm_value) * total_act_vol * ((api.Pricing * 1000) / (100 * api.Grammage));
  //     tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex].TotalCost = !secondType ? 0 : secondType.toFixed(2) * 1;
  //   }
  //   if (tempData.NormType === "608618a4-50a0-4b2c-bdb1-8eac4e5e3238") {  // NormType = DISCOUNT BY VALUE
  //     console.log('THIRD', tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex])
  //     let thirdType = (norm_value * 1000 / api.Grammage) * total_act_vol;
  //     tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex].TotalCost = !thirdType ? 0 : thirdType.toFixed(2) * 1;
  //   }
  //   let roiNumerator;
  //   setTimeout(() => {

  //     roiNumerator = extra_profit - api.TotalCost;
  //     let roi = 100 * roiNumerator.toFixed(2) * 1 / api.TotalCost;
  //     tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex].RoiNumerator = roiNumerator;
  //     tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex].Roi = roi.toFixed(2) * 1;

  //     if (api.TotalCost && roiNumerator) {
  //       this.projectRoi(skuIndex, promoInd, api, roiNumerator);
  //     }

  //   }, 0);

  //   console.log('191=>', tempData.Promotions[promoInd].SkuVolumeAnalysis[skuIndex])
  //   // this.setState({
  //   //   data: tempData
  //   // })
  // }

  // projectRoi(skuIndex, promoInd, api, roiNumerator) {
  //   let tempData = JSON.parse(JSON.stringify(this.state.data));
  //   let sum_totalCost = [0];
  //   let roi_numerator = [0];
  //   for (
  //     let i = 0;
  //     i < tempData?.Promotions[promoInd]?.SkuVolumeAnalysis.length;
  //     i++
  //   ) {
  //     let sku = tempData?.Promotions[promoInd]?.SkuVolumeAnalysis[i];
  //     let constint = parseFloat(sku.TotalCost);
  //     sum_totalCost.push(constint);
  //     if (!sku.RoiNumerator) {

  //       let extraprofit = (parseFloat(sku.IncVolume)) * sku.GpTon * 1000;
  //       let sku_roinumerator = extraprofit - constint;
  //       roi_numerator.push(sku_roinumerator);
  //     } else {
  //       if (
  //         roi_numerator.length - 1 <=
  //         tempData?.Promotions[promoInd]?.SkuVolumeAnalysis.length
  //       ) {

  //         roi_numerator.push(sku.RoiNumerator);
  //       } else {
  //       }
  //     }
  //   }
  //   let add_totalCost = sum_totalCost.reduce((a, b) => {
  //     return a + b;
  //   });
  //   let add_roinumerator = roi_numerator.reduce((a, b) => {
  //     return a + b;
  //   });
  //   let result = (add_roinumerator / add_totalCost) * 100;
  //   tempData.Promotions[promoInd].Roi = !result ? 0 : result.toFixed(2) * 1;
  //   this.setState({
  //     data: tempData
  //   },
  //     () => this.grnd_total(promoInd)
  //   )
  //   // this.setState(
  //   //   produce((prevState) => {
  //   //   }),
  //   //   () => this.grnd_total(promoInd)
  //   // );


  // }

  // grnd_total(promoInd) {

  //   try {
  //     this.grandTotalCalculation(promoInd)
  //   }
  //   catch (e) {
  //   }
  // }

  grandTotalCalculation = () => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));

    let gton = [0];
    let baseline = [0];
    let totalvol = [0];
    let totalcost = [0];
    let roi = [0];
    let incvol = [0];
    let activatedaws = [0];
    let totalactivatedvol = [0];
    // let activatedweeks = [0];
    let postvol = [0];
    let dndsvol = [0];
    let roinumerator = [0];
    // let promotion_basedCost = [0];
    tempData.Promotions.forEach((e, i) => {
      e.SkuVolumeAnalysis.forEach((elem, j) => {
        let parsedtotal_cost = parseFloat(elem.TotalCost);
        baseline.push(elem.Baseline)
        totalvol.push(parseFloat(elem.TotalVolume))
        totalcost.push(parsedtotal_cost)
        incvol.push(parseFloat(elem.IncVolume))
        activatedaws.push(elem.ActivatedAws)
        totalactivatedvol.push(parseFloat(elem.TotalActivatedVolume))
        postvol.push(elem.PostAws)
        dndsvol.push(parseFloat(elem.DndsVolume))
        let extraprofit = (parseFloat(elem.IncVolume)) * elem.GpTon * 1000;
        let sku_roinumerator = extraprofit - parsedtotal_cost;
        roinumerator.push(parseFloat(sku_roinumerator))
        gton.push(extraprofit)
        // if (promoInd === i) {
        //   promotion_basedCost.push(parsedtotal_cost)

        // }
      })
      roi.push(parseFloat(e.Roi))

    })
    let gton_result = gton.reduce((a, b) => { return a + b })
    let totalactivatedvol_result = totalactivatedvol.reduce((a, b) => { return a + b })
    let baseline_result = baseline.reduce((a, b) => { return a + b })
    let totalvol_result = totalvol.reduce((a, b) => { return a + b })
    let totalcost_result = totalcost.reduce((a, b) => { return a + b })
    // let roi_result = roi.reduce((a, b) => { return a + b })
    let incvol_result = incvol.reduce((a, b) => { return a + b })
    let activatedaws_result = activatedaws.reduce((a, b) => { return a + b })
    // let activatedweeks_result = activatedweeks.reduce((a, b) => { return a + b })
    let postvol_result = postvol.reduce((a, b) => { return a + b })
    let dndsvol_result = dndsvol.reduce((a, b) => { return a + b })
    let roinumerator_result = roinumerator.reduce((a, b) => { return a + b })
    // let promotion_basedCostResult = promotion_basedCost.reduce((a, b) => { return a + b })
    // let finalTcost = parseFloat(promotion_basedCostResult.toFixed(2))
    let finalBaseline = parseFloat(baseline_result.toFixed(2))
    let finalTVol = parseFloat(totalvol_result.toFixed(2))
    let finalUpperTcost = parseFloat(totalcost_result.toFixed(2))
    let totalRow_roi = (roinumerator_result / totalcost_result) * 100
    let finalTRow = parseFloat(totalRow_roi.toFixed(2))
    let finalTIncVol = parseFloat(incvol_result.toFixed(2))
    let finalActVol = parseFloat(totalactivatedvol_result.toFixed(2))
    let finalPostVol = parseFloat(postvol_result.toFixed(2))
    let finalDnds = parseFloat(dndsvol_result.toFixed(2))
    let finalAws = parseFloat(activatedaws_result.toFixed(2))

    // tempData.Promotions[promoInd].TotalCost = finalTcost;
    tempData.GpTon = gton_result.toFixed(2) * 1;
    tempData.Baseline = finalBaseline;
    tempData.TotalVolume = finalTVol;
    tempData.TotalCost = finalUpperTcost;
    tempData.Roi = !totalRow_roi ? 0 : finalTRow;
    tempData.IncVolume = finalTIncVol;
    tempData.ActivatedAws = finalAws;
    tempData.TotalActivatedVolume = finalActVol;
    tempData.PostVolume = finalPostVol;
    tempData.DndsVolume = finalDnds;

    this.setState({
      data: tempData
    },
      () => this.save_propso_in_idb(gton_result)
    )
    // this.setState(
    //   produce((prevState) => {

    //     let changeObject = Object.create(this.state.data);
    //     prevState.data = changeObject;


    //   }),
    //   () => {
    //     this.save_propso_in_idb(gton_result)
    //   }
    // )

  }

  save_propso_in_idb(gton_result) {
    // this.setState({forceState:true})
    this.forceUpdate()
    const saveData = async (gton_result) => {
      try {
        if (!("indexedDB" in window)) {
          console.warn("IndexedDB not supported");
          return;
        }

        const dbName = "gt_form";
        const storeName = "product_store";
        const version = 1; //versions start at 1

        const db = await openDB(dbName, version, {
          upgrade(db, oldVersion, newVersion, transaction) {
            const store = db.createObjectStore(storeName);       // eslint-disable-line
          }
        });
        const tx = await db.transaction(storeName, "readwrite");
        const store = await tx.objectStore(storeName);

        let data = JSON.parse(JSON.stringify(this.props.draftData?.PreOpso));
        let tempData = JSON.parse(JSON.stringify(this.state.data));
        data.GpTon = tempData.GpTon
        data.Baseline = tempData.Baseline
        data.TotalVolume = tempData.TotalVolume
        data.TotalCost = tempData.TotalCost
        data.Roi = tempData.Roi
        data.IncVolume = tempData.IncVolume
        data.ActivatedAws = tempData.ActivatedAws
        data.TotalActivatedVolume = tempData.TotalActivatedVolume
        // data.ActivityDuration= activatedweeks_result;
        data.ActivatedAws = tempData.ActivatedAws
        data.PostVolume = tempData.PostVolume
        data.DndsVolume = tempData.DndsVolume

        const value = await store.put({ key: "pre_123", "value": data }, "preopso_detail");       // eslint-disable-line

        await tx.dones;


      } catch (e) {
        // alert(e.message)
        console.warn(e.message)
      }
    }

    saveData(gton_result)

  }

  sku_normChange = (e, prom_index, sku_index) => {  //not in use
    const {

      data,
    } = this.state;
    if (sku_index) {
      let value = e.target.value;
      this.setState(
        produce((prevState) => {
          let dataObject1 = Object.create(data);
          prevState.data = dataObject1;
          prevState.data.Promotions[prom_index].SkuVolumeAnalysis[
            sku_index
          ].Norm = value * 1;
          prevState.data.Promotions[prom_index].Norm = value * 1;
        }),
        () => this.dndsVal(data.Promotions[prom_index].SkuVolumeAnalysis, prom_index, sku_index, data.ActivityDuration)
        // here sequesncy is pre activated weeks, activated weks, dip weeks
      );
    } else {


      data.Promotions[prom_index].SkuVolumeAnalysis.forEach((item, i) => {
        let value = e.target.value;
        this.setState(
          produce((prevState) => {
            let dataObject1 = Object.create(data);
            prevState.data = dataObject1;
            prevState.data.Promotions[prom_index].SkuVolumeAnalysis[
              i
            ].Norm = value;
            prevState.data.Promotions[prom_index].Norm = value;
          }),
          () => this.dndsVal(item, prom_index, i, this.state.data.ActivityDuration) // here sequesncy is pre activated weeks, activated weks, dip weeks
        );
      });
    }
  };

  currentNormChange = (e) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    let value = e.target.value;
    this.props.handleIsCalculateButtonClicked(false);
    tempData.Norm = parseFloat(value);
    if (tempData?.Promotions?.length) {
      tempData.Promotions.forEach((item) => {
        if (item?.SkuVolumeAnalysis?.length) {
          item.SkuVolumeAnalysis.forEach((sku) => {
            sku.Norm = parseFloat(value)
          })
        }
      })
      this.setState({
        data: tempData
      },
        () => this.handleAllMskusCalculation()
      )
    }
  };

  handleAllMskusCalculation = () => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    if (tempData?.Promotions?.length) {
      tempData.Promotions.forEach((item, promoInd) => {
        if (item?.SkuVolumeAnalysis?.length) {
          item.SkuVolumeAnalysis.forEach((sku, skuIndex) => {
            console.log("467=> SKU DNDS", sku, skuIndex, promoInd)
            let dnds = ((sku.PreActivityWeeks + tempData.ActivityDuration + sku.DipWeeks) * sku.Baseline);
            sku.DndsVolume = !dnds ? 0 : dnds.toFixed(2) * 1;
          })
        }
      })

      this.setState({
        data: tempData
      },
        () => this.handleAllMskusTotalVolCalculation()
      )
    }
  };



  handleAllMskusTotalVolCalculation() {
    let tempData = JSON.parse(JSON.stringify(this.state.data));

    if (tempData?.Promotions?.length) {
      tempData.Promotions.forEach((item, promoInd) => {
        if (item?.SkuVolumeAnalysis?.length) {
          item.SkuVolumeAnalysis.forEach((sku, skuIndex) => {
            // let norm_delta = (parseFloat(sku.Norm) / parseFloat(sku.OrgNorm)) * 100;
            let norm_delta = 10
            let total_activatedVol = sku.ActivatedAws * tempData.ActivityDuration

            let total_vol = (sku.PreActivityWeeks * sku.Baseline) + (tempData.ActivityDuration * (sku.ActivatedAws + sku.Baseline)) + (sku.DipWeeks * sku.PostAws);

            let incValue = total_vol - sku.DndsVolume; // this is also extra volume
            let extra_profit = (incValue.toFixed(2) * 1) * sku.GpTon * 1000;
            console.log("508=> SKU DNDS", { norm_delta }, { total_activatedVol }, { incValue }, { total_vol }, { extra_profit })
            sku.TotalActivatedVolume = !total_activatedVol ? 0 : total_activatedVol.toFixed(2) * 1;
            sku.IncVolume = !incValue ? 0 : incValue.toFixed(2) * 1;
            sku.TotalVolume = !total_vol ? 0 : total_vol.toFixed(2) * 1;
            tempData.extra_profit = extra_profit.toFixed(2) * 1;
            sku.Percentage = !norm_delta || norm_delta === Infinity ? 0 : norm_delta.toFixed(2) * 1;

            let total_act_vol = (sku.Baseline + sku.ActivatedAws) * tempData.ActivityDuration;
            let total_cost = 0;
            if (tempData.NormType === "b2e41bb3-a11d-48f1-b041-b9c04c956e7a") {  // NormType = FREE SKUs
              console.log('FIRST', sku)
              let firstType = sku.Norm * total_act_vol * (sku.Pricing * 1000 / sku.Grammage);
              total_cost = !firstType ? 0 : firstType.toFixed(2) * 1;
              sku.TotalCost = total_cost;
            }
            if (tempData.NormType === "2a48252b-4179-4090-98ac-a437728d5ed6" || item.Slabs) {  // NormType = DISCOUNT BY %AGE
              console.log('SECOND', sku)
              let secondType = parseFloat(sku.Norm) * total_act_vol * ((sku.Pricing * 1000) / (100 * sku.Grammage));
              total_cost = !secondType ? 0 : secondType.toFixed(2) * 1;
              sku.TotalCost = total_cost
            }
            if (tempData.NormType === "608618a4-50a0-4b2c-bdb1-8eac4e5e3238") {  // NormType = DISCOUNT BY VALUE
              console.log('THIRD', sku)
              let thirdType = (sku.Norm * 1000 / sku.Grammage) * total_act_vol;
              total_cost = !thirdType ? 0 : thirdType.toFixed(2) * 1;
              sku.TotalCost = total_cost

            }
            let roiNumerator;
            roiNumerator = extra_profit - total_cost;
            let roi = 100 * roiNumerator.toFixed(2) * 1 / total_cost;
            sku.RoiNumerator = roiNumerator;
            sku.Roi = roi.toFixed(2) * 1;

            // if (api.TotalCost && roiNumerator) {
            //   this.projectRoi(skuIndex, promoInd, api, roiNumerator);
            // }

          })
        }
      })
      console.log("508=> SKU DNDS", { tempData })

      this.setState({
        data: tempData
      },
        () => this.calculateActivityRoi()
      )
    }
  };

  calculateActivityRoi = () => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    let sum_totalCost = [0];
    let roi_numerator = [0];

    if (tempData?.Promotions?.length) {
      tempData.Promotions.forEach((item, promoInd) => {
        if (item?.SkuVolumeAnalysis?.length) {
          item.SkuVolumeAnalysis.forEach((sku, skuIndex) => {
            sum_totalCost.push(parseFloat(sku.TotalCost));

            if (!sku.RoiNumerator) {
              let extraprofit = (parseFloat(sku.IncVolume)) * sku.GpTon * 1000;
              let sku_roinumerator = extraprofit - parseFloat(sku.TotalCost);
              roi_numerator.push(sku_roinumerator);
            }
            else {
              if (roi_numerator.length - 1 <= item.SkuVolumeAnalysis.length) {
                roi_numerator.push(sku.RoiNumerator);
              }
            }
          })
        }
      })
      let add_totalCost = sum_totalCost.reduce((a, b) => {
        return a + b;
      });
      let add_roinumerator = roi_numerator.reduce((a, b) => {
        return a + b;
      });
      let result = (add_roinumerator / add_totalCost) * 100;
      console.log('581=>', result)
      tempData.Roi = !result || result === Infinity ? 0 : result.toFixed(2) * 1;

      this.setState({
        data: tempData
      }, () => this.grandTotalCalculation())
    }
  }

  onKeyDown = (e) => { //not in use
    if (e.keyCode === 8) {
      this.setState({ noNewProject: true });
    }
  };

  componentDidMount() {
    let productData = []       // eslint-disable-line
    try {

      const getData = async () => {
        if (!("indexedDB" in window)) {
          console.warn("IndexedDB not supported");
          return;
        }
        const dbName = "gt_form";
        const storeName = "product_store";
        const version = 1; //versions start at 1

        const db = await openDB(dbName, version, {

        });
        let result = await db
          .transaction(storeName)
          .objectStore(storeName)
          .get("preopso_detail");

        let isRestrict = await db
          .transaction(storeName)
          .objectStore(storeName)
          .get("is_newPromotion");
        this.props.isRestrict_fromIdb(isRestrict && isRestrict.value)
        productData = result ? result.value : []

      }

      getData();



      this.props.get_allEnum();
      console.log('521=>', this.props.draftData)
      this.setState({
        data: this.props.draftData.PreOpso,
        metaData: this.props.draftData?.ActivityMetadata?.product_detail
          ?.promotion_type,
      });


    } catch (e) {
    }
  }


  calculateHandle = (e) => {
    this.setState({ isLoading: true, isCalculationResult: true });
    let calculate = {
      _id: this.props.draftData?.guid,
      PreOpso: {
        PreOpso: this.props.draftData.PreOpso,
      },
    };
    this.props.handleIsCalculateButtonClicked(true);
    this.props.post_calculate_preOpso(calculate);
  };

  PreOpsoData(data, flag) {
    console.log('547=>', data)
    const saveData = async (data, flag) => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }

      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          const store = db.createObjectStore(storeName);       // eslint-disable-line
        },
      });
      const tx = await db.transaction(storeName, "readwrite");
      const store = await tx.objectStore(storeName);
      const value = await store.put(
        { key: "pre_123", value: data },
        "preopso_detail"
      );
      const isSave = await store.put(
        { key: "draft_123", value: flag },
        "is_draft_saved"
      );
      // }
      await tx.dones;

      let resp;
      let txs;
      let obj;
      resp = await db;
      txs = await resp.transaction(storeName);
      obj = await txs.objectStore(storeName);
      let productDataResult = await obj.get(value);
      let draft = await obj.get(isSave);       // eslint-disable-line
      preOpsoData = productDataResult ? productDataResult.value : [];
      draft = draft ? draft.value : [];
      setTimeout(() => {
        this.props.call_back(this.props.draft_state === true ? true : flag);
      }, 100);
    };

    saveData(data, flag);

    // isSaveDraft = false;
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevProps.calculatedData !== this.props.calculatedData) {
      if (this.props.calculatedData.guid) {
        // ToastsStore.success("calculate api success");
        CustomToast('success', 'calculate api success')
        const { draftData } = this.props
        draftData.PreOpso = this.props.calculatedData?.PreOpso
        this.setState({
          data: this.props.calculatedData?.PreOpso,
          isLoading: false,
          iscalc: true,
          trash: true
        })
        setTimeout(() => {
          this.PreOpsoData(this.props.calculatedData?.PreOpso, true)
        }, 800);

      } else {
        this.setState({ isLoading: false });
      }
    }
    if (prevProps.calculationError !== this.props.calculationError) {
      let data = this.props.calculationError?.PreOpso?.Promotions &&
        Object.entries(this.props.calculationError?.PreOpso?.Promotions)
      data && data.forEach(([key, value]) => {
        let arr = Object.entries(value)
        arr.forEach(([keys, values]) => {
          CustomToast('error', `${keys} ${values[0]}`)
        })
      })
      this.setState({ isLoading: false })
    }
    if (this.state.data !== prevState.data) {
      console.log('630=>', this.state.data, prevState.data)
      prevState.data?.Promotions !== undefined
        ? this.PreOpsoData(this.state.data, true)
        : void 0;
      prevState.data?.Promotions !== undefined && this.props.isRestrict_fromIdb(true, true)

    }
  }

  buyTypeSelectChange = (value, index) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));

    if (value === "795f46df-01a3-48f9-9143-06ea6c2cf658") {
      tempData.ApplyUom = null
      tempData.BuyUom = null
      tempData.ApplyOn = "47bf77b7-8768-4718-9e42-9a36bc2bfcaf"
      this.setState({
        data: tempData
      })
    }
    if (value) {
      tempData.BuyType = value;
      value === 'e7130818-5d92-4618-8107-efb0d3c623c4' &&
        tempData.BuyUom === '48568dac-993e-4d7d-9647-374aa1e136eb' ?
        tempData.BuyUom = null : void 0;
      this.setState({
        data: tempData
      })
    }
  };

  buyUomSelectChange = (value, index) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    if (value) {
      tempData.BuyUom = value;
      if (value === "795f46df-01a3-48f9-9143-06ea6c2cf658") {
        tempData.ApplyUom = null
        tempData.BuyUom = null
      }
      if (tempData.NormType !== "2a48252b-4179-4090-98ac-a437728d5ed6" &&
        tempData.BuyType === "e7130818-5d92-4618-8107-efb0d3c623c4") {

        if (value === '4f031ace-badf-4340-a2e9-dd7363fbc3de') { //pc
          tempData.ApplyUom =
            'd1496288-73be-4de8-a615-8d568e8c6b4f'
        } else if (value === 'bcaed8e2-588d-446d-982f-66987e903dd3') { //cs
          tempData.ApplyUom = '8a3e952e-ec37-4b56-b869-be65efaf4ac2'
        } else if (value === 'c5ddb6ef-847e-44fc-9950-debe5a1d3793' &&
          tempData.NormType !== "b2e41bb3-a11d-48f1-b041-b9c04c956e7a") { //kg
          tempData.ApplyUom = 'd2f775a7-5320-4b0b-b3c4-45dd8378bf47'

          tempData.ApplyOn = 'ddc4666c-6dc8-427e-a077-e4aa6bfc1273'

        } else if (value === 'e907be85-2af9-4ca6-9c94-79dcde6507a1' &&
          tempData.NormType !== "b2e41bb3-a11d-48f1-b041-b9c04c956e7a") { // ltr
          tempData.ApplyUom = '8f031b99-3e78-4374-88e7-5999a1ee81a7'
          tempData.ApplyOn = 'df316d1d-1486-4e37-87a3-f2fb2315d8b0'
        }
      }
      this.setState({
        data: tempData
      })
    }
  };

  applyUomSelectChange = (value, index) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    tempData.ApplyUom = value;
    if (value) {
      this.setState({
        data: tempData
      })
    }
  };

  applyOnSelectChange = (value, index) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    tempData.ApplyOn = value;
    if (value) {
      this.setState({
        data: tempData
      })
    }
  };

  otherDetailsChange = (value, index) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    tempData.OtherDetails = value
    this.setState({
      data: tempData
    }
    );
  };

  buyFromChange = (e, index) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    let value = e.target.value;
    value = parseFloat(value);
    tempData.BuyFrom = value;
    this.setState({
      data: tempData
    })
  };

  buyToChange = (e, index) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    let value = e.target.value;
    value = parseFloat(value);
    tempData.BuyTo = value;
    this.setState({
      data: tempData
    })
  };

  budgetRestrictionChange = (e, index) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    let value = e.target.value;
    value = parseFloat(value);
    tempData.BudgetRestriction = value;
    this.setState({
      data: tempData
    })
  };

  handelNormTypeChangeFromParent = (val) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    let value = val.value;
    tempData.NormType = value;
    if (tempData?.Promotions?.length) {
      tempData.Promotions.forEach(item => {
        if (item?.SkuVolumeAnalysis?.length) {
          item.SkuVolumeAnalysis.forEach(sku => {
            sku.NormType = value
          })
        }
      })
      this.setState({
        data: tempData
      },
        () => this.handleAllMskusCalculation())
    }
  };

  handlePreOpsoParentMskuIncAwsChange = (e, ind) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    let value = e.target.value;
    value = parseFloat(value);
    tempData.preopso_mskus[ind].ActivatedAws = value;
    if (tempData?.Promotions?.length) {
      tempData.Promotions.forEach(item => {
        if (item?.SkuVolumeAnalysis?.length) {
          item.SkuVolumeAnalysis[ind].ActivatedAws = value;
        }
      })
      this.setState({
        data: tempData
      },
        () => this.handleAllMskusCalculation())
    }
  };

  handlePreOpsoParentMskuPostAwsChange = (e, ind) => {
    let tempData = JSON.parse(JSON.stringify(this.state.data));
    let value = e.target.value;
    value = parseFloat(value);
    tempData.preopso_mskus[ind].PostAws = value;
    if (tempData?.Promotions?.length) {
      tempData.Promotions.forEach(item => {
        if (item?.SkuVolumeAnalysis?.length) {
          item.SkuVolumeAnalysis[ind].PostAws = value;
        }
      })
      this.setState({
        data: tempData
      },
        () => this.handleAllMskusCalculation())
    }
  };

  render() {
    const { enumData } = this.props;

    let data = this.state.data ? this.state.data : this.props.draftData?.PreOpso
    console.log('796=>', data)
    return !data && !data?.Promotions && !enumData ? (
      <Loader flag={true} />
    ) : (
      <>
        <div style={this.state.isLoading === true ? { pointerEvents: 'none', cursor: 'pointer' } : void 0} >
          <div className="product_detail">
            <p>Promotion Detail</p>
          </div>
          <div className="label_id">
            <label for="prom"> Activity Code</label>
            <label for="prom" style={{ display: "block", paddingTop: "2.2vh" }}>
              {!data ? void 0 : data && data.ActivityCode}{" "}
            </label>
          </div>
          <div className='promotion_main_page'>
            {
              data &&

              <MTFTS
                item={data}
                budgetRestrictionChange={this.budgetRestrictionChange}
                buyUomSelectChange={this.buyUomSelectChange}
                applyUomSelectChange={this.applyUomSelectChange}
                buyTypeSelectChange={this.buyTypeSelectChange}
                selectedSkuNormType={this.state.selectedSkuNormType}
                handelNormTypeChangeFromParent={this.handelNormTypeChangeFromParent}
                otherDetailsChange={this.otherDetailsChange}
                buyFromChange={this.buyFromChange}
                currentNormChange={this.currentNormChange}
                buyToChange={this.buyToChange}
                applyOnSelectChange={this.applyOnSelectChange}
                enumData={enumData ? enumData : []}
                index={0}
                selectedBuyUom={this.state.selectedBuyUom}
                selectedAppyOn={this.state.selectedAppyOn}
                selectedAppyUom={this.state.selectedAppyUom}
                selectedBuyType={this.state.selectedBuyType}
                data={data}
                stateselectedSkuNormType={this.state.stateselectedSkuNormType}
                isExtended={this.props.draftData?.IsExtended}
                handlePreOpsoParentMskuIncAwsChange={this.handlePreOpsoParentMskuIncAwsChange}
                handlePreOpsoParentMskuPostAwsChange={this.handlePreOpsoParentMskuPostAwsChange}
              />
            }

            {
              data && data?.Promotions.map((item, index) => (
                <div className='preopso-customer-cont'>
                  <div className='customer-details'>
                    <span className='customer-title'>{item.customer_name}</span>
                    <span className='customer-project-code'>Project Code: {item.ProjectCode}</span>
                  </div>
                  <div>
                    <div>
                      {
                        item.SkuVolumeAnalysis.map((sku_item, sku_index) => (
                          <MtftsMskus
                            sku_item={sku_item}
                            sku_index={sku_index}
                            item={item}
                            awsBaseline={this.state.awsBaseline}
                            data={data}
                            index={index}
                            enumData={enumData ? enumData : []}
                            baselineChange={this.baselineChange}
                            formType={this.props.currentForm}
                          />
                        ))
                      }
                    </div>
                  </div>
                </div>
              ))
            }


            <TOTALROW
              data={data}
              formType={this.props.currentForm}
            />
          </div>
          <div className="lower_section">
            {this.props.currentForm !== 'ic' &&
              <button
                title='Model will suggest AWS Baseline, Inc AWS, Post AWS and accordingly Total Vol, Total Cost, ROI and other related calculations for all Master SKUs based on its logic, according to the selected norm and norm type'
                type="button"
                className="calculate_btn"
                style={this.state.isLoading === true ? { pointerEvents: 'none' } : void 0}
                onClick={this.state.isLoading === false && this.calculateHandle}
              >
                {this.state.isLoading === true ? "Loading.." : "Get Machine Suggested ROI"}
              </button>
            }
            <h2 className="statement">
              Return On Investment (ROI) is{" "}
              <span> {data && data.Roi}% </span>{" "}
            </h2>
          </div>
        </div>
      </>
    );
  }

}

// redux

const mapStateToProps = (state) => {
  return {
    enumData: state.CreatePromotionReducer.enumData,
    promotionData: state.CreatePromotionReducer.promotionData,
    calculatedData: state.CreatePromotionReducer.calculatedData,
    calculationError: state.CreatePromotionReducer.calcError,
    newProject: state.CreatePromotionReducer.newProject,
    draftData: state.CreatePromotionReducer.draftData,
    submitApproval: state.ApprovalReducer.submitApproval,
    error: state.ApprovalReducer.error,
    isPromoCSVFileDownloading: state.PromotionReducer.isPromoCSVFileDownloading,
    promoCSVData: state.PromotionReducer.promoCSVData,
    isCalculateCSVPromoloading: state.PromotionReducer.isCalculateCSVPromoloading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    get_allEnum: () => {
      return dispatch(CreatePromotion.get_allEnum());
    },
    post_calculate_preOpso: (data) => {
      return dispatch(CreatePromotion.post_calculate_preOpso(data));
    },
    post_preOpso_newProject: (activitycode, norm) => {
      return dispatch(CreatePromotion.post_preOpso_newProject(activitycode, norm));
    },
    downloadPromoCSV: (data) => {
      return dispatch(PromotionMiddleware.downloadPromoCSV(data));
    },
    calculatePreopsoFromCSV: (id, data) => {
      return dispatch(PromotionMiddleware.calculatePreopsoFromCSV(id, data));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MTFTSPromotion);